import { Menu, User, LogOut } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { authClient } from "../auth-client";
import { NotificationBell } from "./notifications/NotificationBell";

interface HeaderProps {
  toggleDrawer: () => void;
  userEmail: string;
}

export function Header({ toggleDrawer, userEmail }: HeaderProps) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await authClient.signOut();
      navigate("/signin");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 justify-between items-center">
          <div className="flex items-center">
            <button
              onClick={toggleDrawer}
              className="p-2 rounded-md text-secondary-400 hover:text-secondary-500 hover:bg-secondary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            >
              <Menu className="h-6 w-6" />
            </button>
            <Link to="/" className="ml-4 flex items-center space-x-3">
              <span className="text-xl font-semibold text-secondary-900">
                Custodio AI
              </span>
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <NotificationBell />
            <div className="flex items-center space-x-2">
              <User className="h-5 w-5 text-secondary-400" />
              <span className="text-sm text-secondary-600">{userEmail}</span>
            </div>
            <button
              onClick={handleSignOut}
              className="flex items-center space-x-2 p-2 rounded-md text-secondary-400 hover:text-secondary-500 hover:bg-secondary-100"
            >
              <LogOut className="h-5 w-5" />
              <span className="text-sm">Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
